export enum ClientToggleTabs {
  investmentInformation = 'investmentInformation',
  clientInformation = 'clientInformation'
}

export enum StatementTypes {
  transactionSummary = 'Transaction summary',
  transactionDetail = 'Transaction detail',
  fundDetail = 'Fund detail',
  internalRateOfReturnInv = 'Internal rate of return (investment)'
}

export enum StatementOption {
  netIRR = 'Net IRR (Reflects the investment return after all fees have been deducted)',
  grossIRR = 'Gross IRR (Reflects the investment return before administration and financial intermediary fees have been deducted)',
  inclIRR = 'Include internal rate of return (IRR)'
}

export enum StatementPeriodTypeOptions {
  standardPeriods = 'standard periods',
  toCurrentDate = 'to current date',
  customPeriod = 'custom period'
}

export enum PeriodPresetOptions {
  thirtyDays = '30 days',
  ninetyDays = '90 days',
  sixMonths = '6 months',
  oneYear = '1 year',
  threeYears = '3 years',
  fiveYears = '5 years',
  sinceInception = 'Since inception',
  yearToDate = 'Year to date'
}

export enum TransactionEventTypeMock {
  interest = 'interest',
  dividendDeclaration = 'dividendDeclaration',
  interestDeclaration = 'interestDeclaration',
  fees = 'fees'
}
